module.exports = __webpack_public_path__ + "img/vc.11c40405.svg";